<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M248.615 178.985H243.399V181.667L214.887 203.632V130.358L249.779 105.34C250.669 104.643 251.187 103.58 251.187 102.454V100.067C251.187 98.3325 249.831 97.7117 248.71 97.7117H50.3169C48.0833 97.7117 45.9073 98.4157 44.0897 99.7213L7.74412 125.859H7.77612C6.18892 126.742 5.12012 128.438 5.12012 130.377V209.424C5.12012 211.747 7.00172 213.628 9.32492 213.628H212.429C214.023 213.628 215.565 213.097 216.819 212.124L249.895 186.473C250.707 185.846 251.181 184.88 251.181 183.849V181.539C251.181 180.124 250.035 178.972 248.615 178.972V178.985Z"
      class="fill-brand-500"
    />
    <path
      d="M243.558 109.795L214.88 130.358V189.488V203.632L243.392 181.667L243.558 109.795Z"
      class="fill-brand-100"
    />
    <path
      d="M184.339 213.635H197.817V132.489H184.339V213.635Z"
      class="fill-secondary-500"
    />
    <path
      d="M142.893 186.748C150.453 186.748 156.582 180.619 156.582 173.059C156.582 165.498 150.453 159.369 142.893 159.369C135.332 159.369 129.203 165.498 129.203 173.059C129.203 180.619 135.332 186.748 142.893 186.748Z"
      class="fill-secondary-500"
    />
    <path
      d="M21.3824 213.635H34.8608L34.8608 132.489H21.3824L21.3824 213.635Z"
      class="fill-secondary-500"
    />
    <path
      d="M228.346 88.086L112.198 69.1997C109.869 68.8221 107.667 70.2748 107.053 72.4956L62.8671 65.3085L65.5487 48.7965C69.6575 48.6045 73.2159 45.5709 73.9071 41.3469C74.7007 36.5021 71.4111 31.9325 66.5599 31.1389L25.4911 24.4381C20.6463 23.6445 16.0767 26.9341 15.2831 31.7853C14.6111 35.9133 16.9023 39.8365 20.5951 41.3981L13.4591 85.2956C9.41434 85.5516 5.93274 88.5596 5.25434 92.7325C4.46074 97.5772 7.75034 102.147 12.6015 102.94L53.6831 109.641C58.5279 110.435 63.0975 107.145 63.8911 102.294C64.5759 98.1149 62.2143 94.1404 58.4447 92.6236L61.0879 76.3868L105.261 83.5676C105.043 86.1148 106.816 88.4445 109.382 88.8605L225.171 107.689C230.586 108.572 235.686 104.892 236.57 99.4781C237.453 94.0637 233.773 88.9629 228.358 88.0797L228.346 88.086Z"
      class="fill-brand-300"
    />
    <path
      d="M48.8578 213.635H55.6802L55.6802 132.489H48.8578L48.8578 213.635Z"
      class="fill-secondary-500"
    />
    <path
      d="M246.451 196.668C244.454 188.643 239.085 182.627 231.878 179.811L222.528 187.12C230.195 187.228 235.84 191.6 237.645 198.851C239.277 205.424 237.184 214.057 228.819 218.531C220.281 223.094 199.974 223.004 178.477 222.915C173.593 222.896 168.582 222.87 163.494 222.902C160.979 222.915 158.95 224.976 158.976 227.491C159.008 229.98 161.043 231.984 163.533 231.971C168.582 231.945 173.568 231.971 178.432 231.984C181.549 231.996 184.608 232.009 187.597 232.009C207.309 232.009 223.929 231.433 233.094 226.531C245.76 219.76 248.928 206.652 246.445 196.662L246.451 196.668Z"
      class="fill-secondary-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'RulesLegislations'
  }
</script>
